import { useHandler } from "@redotech/react-util/hook";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";
import * as progressCss from "./walkthrough-progress-bar.module.css";
import { WalkthroughSection } from "./walkthrough-types";

export const WalkthroughProgressBar = memo(function WalkthroughProgressBar({
  section,
  totalSections,
  dismiss,
}: {
  section: WalkthroughSection;
  totalSections: number;
  dismiss(): void;
}) {
  const [confirming, setConfirming] = useState(false);

  const handleDismissClick = useHandler(() => {
    if (confirming) {
      dismiss();
    } else {
      setConfirming(true);
    }
  });

  const handleCancel = useHandler(() => {
    setConfirming(false);
  });

  const progress =
    totalSections <= 1 ? 100 : ((section.id - 1) / (totalSections - 1)) * 100;

  return (
    <div className={progressCss.container}>
      <Flex align="center" justify="space-between" mb="xs">
        {confirming ? (
          <Flex align="center" gap="sm">
            <Text fontSize="xs" textColor="tertiary">
              Dismiss walkthrough?
            </Text>
            <RedoButton
              hierarchy="primary"
              onClick={handleDismissClick}
              size="xs"
              text="Yes, dismiss"
              theme="destructive"
            />
            <RedoButton
              hierarchy="tertiary"
              onClick={handleCancel}
              size="xs"
              text="Cancel"
            />
          </Flex>
        ) : (
          <RedoButton
            hierarchy="tertiary"
            onClick={handleDismissClick}
            size="xs"
            text="Dismiss walkthrough"
          />
        )}
        <Text fontSize="xs" fontWeight="medium" textColor="tertiary">
          Section {section.id} of {totalSections}: {section.title}
        </Text>
      </Flex>
      <div className={progressCss.track}>
        <div className={progressCss.fill} style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
});
